import { render, staticRenderFns } from "./PortMappingHeader.vue?vue&type=template&id=61714e7a&scoped=true&"
import script from "./PortMappingHeader.vue?vue&type=script&lang=js&"
export * from "./PortMappingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61714e7a",
  null
  
)

export default component.exports